import React from 'react';
import logoLight from '../assets/ncb-solac.svg';
import logoDark from '../assets/ncb-solac-dark.svg';
import './BrandPanel.css';

// The centred branded card shown before the app shell exists: the sign-in
// prompt and the session check. Both logos are in the DOM and the theme class
// picks one, so the toggle needs no JavaScript here.
const BrandPanel: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className="brand-panel">
    <div className="card brand-card">
      <img src={logoLight} alt="NCB Solac" className="brand-logo brand-logo-light" />
      <img src={logoDark} alt="NCB Solac" className="brand-logo brand-logo-dark" />
      {children}
    </div>
    <p className="brand-footer text-xs text-muted">Hazcheck Detect · Analytics</p>
  </div>
);

export default BrandPanel;
